<template>
  <div class="comment-item">
    <div class="comment-content">
      <span class="name">
        {{ comment.user.name }}
      </span>
      <span class="name">:&nbsp;</span>
      <span v-html="comment.content" />
    </div>
    <div class="comment-meta">
      <span>
        {{ comment.createDate }}
      </span>
      <span class="comment-action">
        <template v-if="user.uid === comment.user.id">
          <a-divider
            type="vertical"
            :style="{ margin: 0 }"
          />
          <a-button
            type="text"
            size="small"
            class="comment-button"
            @click="deleteComment"
          >
            {{ $t('shared.delete') }}
          </a-button>
        </template>
      </span>
    </div>
  </div>
</template>

<script>
// import * as moment from 'moment'
import { computed } from 'vue'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'
import { message } from 'ant-design-vue'

import { deleteWeeklyComments } from '@/api/weekly.js'

export default {
  name: 'CommentItem',
  props: {
    comment: {
      type: Object,
      required: true
    }
  },
  emits: [
    'delete'
  ],
  setup (props, { emit }) {
    const { t } = useI18n()
    const { state } = useStore()
    const user = computed(() => state.user)
    // function formatDate (dateStr) {
    //   return moment(dateStr).format('YYYY-MM-DD HH:mm:ss')
    // }

    function deleteComment () {
      deleteWeeklyComments(props.comment.id)
        .then(() => {
          message.success(t('okr.comment.deletedMessage'))
          emit('delete')
        })
    }

    return {
      user,
      // formatDate,
      deleteComment
    }
  }
}
</script>

<style lang="less" scoped>
.comment-item {
  margin-top: 8px;
}

.comment-content {
  // display: flex;
  font-size: 14px;

  .name {
    font-weight: bold;
  }
}

.comment-meta {
  font-size: 12px;
}

.comment-action {
  margin-left: 8px;
}

.comment-button {
  font-size: 12px;
}

:deep(.sendComment) {
  display: contents;
}
</style>
